import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import { useSEO } from "@/hooks/useSEO";
import { seoData } from "@/data/seoData";
import Hero from "./components/Hero";
import ContactSection from "./components/ContactSection";
import FloatingButton from "@/pages/home/components/FloatingButton";

export default function Contact() {
  useSEO(seoData.contact);
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <ContactSection />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}